/* global: MarkerData */
import markerSDK from "@marker.io/browser";

const marker = async function () {
  const widget = await markerSDK.loadWidget({
    project: MarkerData.projectId,
    silent: true,
  });

  if (MarkerData.email) {
    widget.setReporter({
      email: MarkerData.email,
      fullName: MarkerData.fullName,
    });
  }
};

marker();
